export const STEP_ICON_CONTAINER_ID = 'step-icon-container';
